import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { riskMapReducer } from './riskMap/riskMapSlice'
import { projectedRiskChartStateReducer } from './projectedRiskChartSlice'
import { projectedExposureChartStateReducer } from './projectedExposureChartSlice'
import { prioritisationMapReducer } from './prioritisationMap/prioritisationMapSlice'

const store = configureStore({
  reducer: {
    riskMap: riskMapReducer,
    prioritisationMap: prioritisationMapReducer,
    projectedRiskChartState: projectedRiskChartStateReducer,
    projectedExposureChartState: projectedExposureChartStateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

const _rootReducer = combineReducers({
  riskMap: riskMapReducer,
  prioritisationMap: prioritisationMapReducer,
  projectedRiskChartState: projectedRiskChartStateReducer,
  projectedExposureChartState: projectedExposureChartStateReducer,
})

export type RootState = ReturnType<typeof _rootReducer>

export default store
